module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/line-chart.493ed5bd.svg";